var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseBold = function SvgCloseBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 12L8.00329 7.99999M8.00329 7.99999L12 4.00656M8.00329 7.99999L12 11.9934M8.00329 7.99999L4.00003 4",
    stroke: "#141414",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
};
export default SvgCloseBold;